module.exports = __webpack_public_path__ + "static/media/plus.4024345c.svg";